import { StyleSheet } from 'react-native'
import { DS } from '../../../../design-system'
import { DSIcon } from '../../../../design-system/Icon'

export const GamesEmptyMessage = ({
  text = 'Create your first game and invite friends to join you',
  icon = 'Suite--Spade'
}: { text?: string; icon?: DSIcon }) => {
  return (
    <DS.Frame alignItems="center" gap={'8'} style={styles.yourGamesContainer}>
      <DS.Icon name={icon} color="Brand/Purple" size={24} />
      <DS.Text variant="Body Large/Regular" textAlign="center">
        {text}
      </DS.Text>
    </DS.Frame>
  )
}

const styles = StyleSheet.create({
  yourGamesContainer: {
    borderRadius: 16,
    borderColor: DS.palette['Brand/Light Grey'],
    borderWidth: 1,
    borderStyle: 'dashed',
    padding: 24
  }
})
